import styled from 'styled-components';

import { color } from '@ovpn/ui/tokens';

import { ProductType } from '@sso/shared/constants';
import { Text } from '@sso/shared/core';

import cvpnBg from './cvpn-background.png';
import asBg from './as-background.png';

export const Container = styled.div<{ $product: ProductType }>`
    display: flex;
    flex-direction: column;
    gap: 4px;
    height: 100px;
    padding: 16px 28px;

    background-color: ${color.neutral.section};
    background-image: url(${({ $product }) => ($product === ProductType.As ? asBg : cvpnBg)});
    background-size: 100% 100%;
    border-radius: 4px;
`;

export const TitleContainer = styled.div`
    display: flex;
    gap: 8px;
    align-items: center;
    justify-content: space-between;
`;

export const Badge = styled(Text)`
    padding: 3px 8px;

    border: 1px solid ${color.neutral.bgHover};
    border-radius: 16px;
`;
